// extracted by mini-css-extract-plugin
export default {"GIACertificate":"LabDialog_GIACertificate__YFe6i","closeIcon":"LabDialog_closeIcon__UXBE5","imgLoaded":"LabDialog_imgLoaded__+ipMP","imgItem":"LabDialog_imgItem__MBZzS"};